// extracted by mini-css-extract-plugin
export default {"panel-header":"Panel_panel-header__kQ-zQ","title":"Panel_title__GWkBr","panel-body":"Panel_panel-body__VI605"};